"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubstrateApi = void 0;
const api_1 = require("@polkadot/api");
const util_1 = require("@polkadot/util");
require("@subsocial/definitions/interfaces/types-lookup");
require("@subsocial/definitions/interfaces/augment-api");
let api = undefined;
/** Get the current open connection to Substrate node. */
const getSubstrateApi = (nodeUrl) => __awaiter(void 0, void 0, void 0, function* () {
    if (api)
        return api;
    const rpcEndpoint = nodeUrl || 'ws://127.0.0.1:9944/';
    const provider = new api_1.WsProvider(rpcEndpoint);
    api = yield api_1.ApiPromise.create({ provider });
    util_1.formatBalance.setDefaults({
        decimals: api.registry.chainDecimals,
        unit: api.registry.chainTokens
    });
    return api;
});
exports.getSubstrateApi = getSubstrateApi;
